import { FC, useEffect, useMemo, useState } from 'react'

import { cn } from '@/app/utils'

import { styles } from './NotificationUnreadCount.constants'

type Variants = 'pinned' | 'badge'

type Props = {
  variant?: Variants
  active?: boolean
  className?: string
  unread?: { count: number }
}

const NotificationUnreadCount: FC<Props> = ({
  variant = 'badge',
  active,
  className,
  unread
}) => {
  const unreadCount = useMemo(
    () => ((unread?.count ?? 0) > 99 ? '99+' : unread?.count),
    [unread?.count]
  )

  const [animationKey, setAnimationKey] = useState(0)

  useEffect(() => {
    setAnimationKey(prevKey => prevKey + 1)
  }, [unreadCount])

  return unreadCount ? (
    <span
      className={cn(
        'rounded-100 bg-bronze-40 font-bold transition-all',
        styles[variant],
        active && styles[`${variant}Active`],
        className
      )}
    >
      <span
        style={{
          animation: 'numberChange 0.5s forwards'
        }}
        key={animationKey}
      >
        {unreadCount}
      </span>
    </span>
  ) : null
}

export default NotificationUnreadCount
